import React from 'react';
export function ArrowUpRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M16.187 6.777L7.5 7V5H19v11.5h-2l.223-8.687L7 18.5 5.5 17 16.187 6.777z"
  }));
}